import { useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { RouterProvider } from "react-router-dom";
import { storeReferrer } from "@/hooks/useReferrer";
import { theme } from "./theme/theme";
import { router } from "./router/Router";
import { Snack } from "./components/Snack";
import { snackStore } from "./stores/Stores";
import "../i18n";

function App() {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const refFromParam = urlParams.get("redirectTo") || urlParams.get("referrer") || urlParams.get("ref");

    if (refFromParam) {
      storeReferrer(refFromParam);
      console.log("App: Stored URL parameter referrer:", refFromParam);
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <RouterProvider router={router} />
      <Snack snackStore={snackStore} />
    </ThemeProvider>
  );
}

export default App;
